import * as React from "react";
import { useSortBy } from "react-instantsearch";
import { Select } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
/* empty css            */
const SortBy = ({ items }) => {
  const { getLabel } = useIntl();
  const getItemLabel = React.useCallback(
    (item) => {
      return item.label ? item.label : item.labelKey ? getLabel(item.labelKey) : "";
    },
    [getLabel]
  );
  const parsedItems = React.useMemo(
    () => items.map((item) => ({ value: item.value, label: getItemLabel(item) })),
    [getItemLabel, items]
  );
  const { refine } = useSortBy({ items: parsedItems });
  const selectOptions = items.reduce((items2, item) => {
    const label = getItemLabel(item);
    if (!label) {
      return items2;
    }
    return {
      ...items2,
      [label]: label
    };
  }, {});
  const handleChange = (newValue) => {
    const item = items.find((item2) => {
      const label = getItemLabel(item2);
      return label === newValue;
    });
    if (item) {
      refine(item.value);
    }
  };
  return /* @__PURE__ */ React.createElement("div", { className: "search-sort", "data-t": "search-sort" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "search-sort",
      name: "search-sort",
      label: getLabel("search.results.sort.sortBy"),
      options: selectOptions,
      required: false,
      onChange: handleChange,
      renderInline: true
    }
  ));
};
export {
  SortBy
};
//# sourceMappingURL=SortBy.js.map
